import React, { useContext, useRef,useState,useEffect } from 'react';
import { ThemeContext } from 'context/themeContext';
import { deleteAttachment, downloadAttachedFiles, getAttachedFiles, getOrders } from '../../container/api';
import { StyledSubTitle, StyledLine } from './css';
import styled from 'styled-components';
import Button from 'components/button';
import MainContext from 'MainContext';
import { uploadAttachedFile } from 'containers/dashboard/container/api';

import { useTranslation } from 'react-i18next';

export const ShippingInformationText = styled.div`
  // position: relative;
  width: ${(props) => (props.width ? props.width : 'unset')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '1.145vw')};
  font-weight: 500;
  color: ${(props) => props.color ?? props.theme.textPrimary};
`;

const AttachmentsWrapper = styled.div`
margin-left:2vw;
`;

const DownloadIcon = styled.div`
  width: 1.3vw;
  height: 1.3vw;
  position: relative;
  transition: background-color 200ms linear;

  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.icons};
  font-size: 1.4vw;
`;

const Wrapper = styled.div`
  width: 25vw;
  border-radius: 4.164vw;
  background-color: ${(props) => (props.selected ? props.theme.pure : props.theme.cardBackground)};
  transition: 200ms linear;
  padding-bottom:1.56vw;
  padding-top:1.56vw;
  padding-left:1.7vw
`;

const ButtonWrapper = styled.div`
  position:absolute;
  right:${(props)=>props.rtlDirection?'30vw':'-10vw'};
  top:5.045vw;
`;

const StyledInput = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 0%;
  display: none;
  cursor: pointer;
`;

const AttachmentWrapper = styled.div`
  position: relative;
  left: ${(props) => props.rtlDirection ? '42%' : '50%'};
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content:space-between;
  width: 26.184vw;
  height: 4.164vw;
  border-radius: 4.164vw;
  background-color: ${(props) => props.theme.cardOnCardBackground};
  padding-right: 1.56vw;
  padding-left:1.56vw;
  box-sizing: border-box;
  margin-bottom: 1.04vw;
`;

const AttachmentNameWrapper = styled.p`
  font-size:1.051vw;
  font-weight: 400;
  color: ${(props) => props.theme.textPrimary};
  margin-left: ${(props)=>props.rtlDirection?'unset':'0.525vw'};
  margin-right: ${(props)=>props.rtlDirection?'0.525vw':'unset'};
`;

const AttachmentExtraWrapper = styled.div`
  display:flex;
  align-items:center;
`;

const DownloadAttachmentWrapper = styled.div`
  background-color: ${(props) => props.theme.inputBackground + '00'};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 200ms linear;
  padding:0.5vw;
  &:hover {
    background-color: ${(props) => props.theme.inputBackground};
  }
`;

const AttachmentFileIcon = styled.div`
  width:1.576vw;
  height:1.576vw;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.icons};
  font-size: 1.6vw;
`;

const StyledContentWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.937vw;
  padding: 1.04vw;
  position:fixed;
  top:-2vw;
  opacity: ${(props) => (props.open ? '1' : '0')};
  left: ${(props) => props.left + 'vw'};
  transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out;
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  z-index:4;
  background-color:${(props) => props.theme.cardOnCardBackground};
  border-radius:2.08vw;
`;

const BinIcon = styled.div`
  height: 1.1452vw;
  margin-right: 0.78vw;

  align-items: center;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.icons};
  font-size: 1.6vw;
`;

const Attachments = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const inputRef = useRef(null);
  const { profile } = useContext(MainContext).login;
  const { t } = useTranslation();
  const { getAttachFileContext,attachments } = useContext(MainContext).orders;
  const { updateToasterContext } = useContext(MainContext).toasters;
  const [attachedFiles, setAttachedFiles] = useState([]);
  const {selectedOrder,invoiceId,updateOpenOrder}=props;

  const onAttachFileClick = () => {
    inputRef.current.click();
  }

  const handleFileChange = (e) => {

    updateToasterContext({
      type: 'info',
      message: `${t('dashboard.order modal.Uploading ...')}`,
    });
    const data = new FormData();
    data.append('attach_file', e.target.files[0])
    data.append('invoiceId', props.invoiceId)
    data.append('orderId', props.selectedOrder._id)
    data.append('fileName', e.target.files[0].name)
    data.append('fileSize', e.target.files[0].size)
    uploadAttachedFile(data).then(() => {
      // props.selectedOrder.UIValues.attachmentsNO++;
      // updateOpenOrder(invoiceId,selectedOrder);

      updateToasterContext({
        type: 'success',
        message: `${t('dashboard.order modal.File has been uploaded successfully.')}`,
      })
      getAttachFileContext(props.id)
    }).catch(() => {
      updateToasterContext({
        type: 'error',
        message: `${t('dashboard.order modal.There was an error uploading the attachment.')}`
      })
    })

  };
  useEffect(() => {
    getAttachedFiles(props.selectedOrder._id).then((result) => {
      //until we remove this extra request and also fix the bug with drag and drop attachmentNO not updating 
      props.selectedOrder.UIValues.attachmentsNO=result.length;
      updateOpenOrder(invoiceId,selectedOrder);
      
      setAttachedFiles(result.reverse());
    }).catch((error) => {
      console.log(error)
    })
  }, [attachments, props.selectedOrder._id])

  const ondownloadAttachmentFile = (value, file_name) => {
    downloadAttachedFiles(props.selectedOrder._id, value).then((response) => {
      const url = URL.createObjectURL(response);
      const a = document.createElement('a');
      a.style = 'display: none';
      a.href = url;
      a.download = file_name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }).catch(() => {
      updateToasterContext({
        type: 'error',
        message: t('dashboard.order modal.The download of the file failed')
      })
    })
  }

  return (
    <AttachmentsWrapper>
      <ButtonWrapper rtlDirection={rtlDirection}>
        <Button
          width="7.5vw"
          onClick={onAttachFileClick}
          text={t('dashboard.order modal.Attach file')}
          size="medium"
          type="primary"
        />
        <StyledInput type="file" name="attachFile" ref={inputRef} onChange={handleFileChange} />
      </ButtonWrapper>
      {
        attachedFiles.length !== 0 && (
          <>
            <StyledLine theme={theme} style={{ marginRight: rtlDirection && '2vw' }} />
            <StyledSubTitle theme={theme} style={{ marginRight: rtlDirection && '2vw' }}>{t('dashboard.order modal.Attachments')}</StyledSubTitle>
          </>
        )
      }

      {
        attachedFiles?.map((value) => (
          <AttachmentWrapper theme={theme} key={value._id} onContextMenu={(e) => props.onContextMenu(e, value._id)} rtlDirection={rtlDirection}>
            <StyledContentWrapper theme={theme} open={value._id === props.rightClickId && props.showRightClick} left={props.leftRightClick} onClick={(e) => props.onDeleteAttachment(e, value._id)}>
              <BinIcon className="icon-bin" theme={theme} />
               {t('dashboard.order modal.Delete')}
            </StyledContentWrapper>
            <AttachmentExtraWrapper>
              <AttachmentFileIcon className="icon-attachment-files-icon" theme={theme}/>
              <AttachmentNameWrapper rtlDirection={rtlDirection} theme={theme}>{value.file_name}</AttachmentNameWrapper>
            </AttachmentExtraWrapper>
            <DownloadAttachmentWrapper theme={theme}>
              <DownloadIcon
                className="icon-second-download"
                theme={theme}
                onClick={() => ondownloadAttachmentFile(value._id, value.file_name)}
              />
            </DownloadAttachmentWrapper>
          </AttachmentWrapper>
        ))
      }
    </AttachmentsWrapper>
  )
}

export default Attachments